import type { Theme } from '@mui/material';

export const styles = {
  buttonList: {
    display: 'flex',
    flexDirection: 'column',
  },

  button: (theme: Theme) => ({
    borderRadius: 0,
    padding: theme.spacing(2),
    justifyContent: 'flex-start',
  }),

  activeButton: (theme: Theme) => ({
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,

    '&:hover': {
      backgroundColor: theme.palette.common.black,
    },
  }),
};
